module.exports = __webpack_public_path__ + "media/images/account/icon1-235656909ef6d34dc339781556bc0514.svg";